import { api } from '../api/client'
import type { CardAccount } from '../api/client'
import { rememberPending } from './pending'

// PaymentsStep is what startPayments did: 'setup' and 'pending' send her to
// the Card payments card (Stripe's setup not started, or under way), 'checkout'
// sent her to Stripe Checkout, 'done' means the API gave her the rung in
// place (nothing to pay today).
export type PaymentsStep = 'setup' | 'pending' | 'checkout' | 'done'

// startPayments moves her toward the Payments rung in the spec's order
// (section 1.1): Stripe's setup first, which is free, then Checkout for the
// £14 once Stripe has approved her. The plan card and the Payments sheet
// both go through here, so a tap on either does the same thing. With no
// account known (card payments not configured, or not loaded) it asks the
// API, which decides.
export async function startPayments(account: CardAccount | null): Promise<PaymentsStep> {
  const step = stripeSetupStep(account)
  if (step) return step
  const result = await api.startCheckout({ rung: 'card_payments' })
  if (result.url) {
    rememberPending('card_payments')
    window.location.assign(result.url)
    return 'checkout'
  }
  return 'done'
}

// stripeSetupStep is what comes first for both paid rungs (spec 1.1; Pro too
// since 2026-10-25, owner): with card payments configured and no approved
// Stripe account, she is sent to the Card payments card, 'setup' before
// Stripe's setup has started and 'pending' while it is under way, and
// nothing is bought. It starts nothing itself (owner, 2026-10-25): the card's
// own Set up card payments starts Stripe's form, once she has read what Stripe
// will ask for. null means she is approved, or card payments are not
// configured and the API decides, so the caller buys.
export function stripeSetupStep(account: CardAccount | null): 'setup' | 'pending' | null {
  if (!account?.available || account.status === 'active') return null
  return account.status === 'none' ? 'setup' : 'pending'
}
